import React from 'react';
import { Button, TickerCarousel, Badge } from '@dopomogai/ui';

type Props = {
  onPrimaryCta?: () => void;
  bonusTitle?: string;
  bonusCtaText?: string;
};

export function InvestHero({ onPrimaryCta, bonusTitle = 'Get $21 signup credits', bonusCtaText = 'Claim $21 and invest' }: Props) {
  return (
    <section className="bg-slate-50 border-b-2 border-black">
      <div className="max-w-6xl mx-auto px-6 py-12 md:py-16">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight">Back the AI workforce</h1>
            <p className="mt-4 text-slate-700 text-lg">
              Co-own earning agents. Non-transferable units. Payouts from profits after costs.
            </p>
            <div className="mt-3 inline-flex items-center gap-2">
              <Badge text={bonusTitle} accentColor="green" />
            </div>
            <div className="mt-6">
              <Button text={bonusCtaText} onClick={onPrimaryCta} />
            </div>
          </div>
          <div>
            <TickerCarousel items={[
              'Seed round live: Ecom Concierge',
              'Transparent payouts, idempotent purchases',
              'Invest responsibly: high-risk, no guarantees',
            ]} itemHeightRem={2.5} />
          </div>
        </div>
      </div>
    </section>
  );
}


